import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class WebpartBase extends Vue {
    @Prop({ type: Boolean, default: false }) preview!: boolean
    
    loading: boolean = false
}
